var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-icon',{attrs:{"color":_vm.types[_vm.type].color}},[_vm._v(_vm._s(_vm.types[_vm.type].icon))])}
var staticRenderFns = []

export { render, staticRenderFns }